import { Bot, Check, Send } from "lucide-react";
import { Reveal } from "../landing/Reveal";

const POWERS = [
  "Job Matching",
  "Interview Preparation",
  "Resume Review",
  "Business Consulting",
  "Food Analytics",
  "Investment Guidance",
];

export const FunzAI = () => (
  <section id="zeno" data-testid="zeno-ai-section" className="relative overflow-hidden py-24 sm:py-32">
    <div aria-hidden="true" className="absolute -right-40 top-24 h-[460px] w-[460px] rounded-full bg-[#635BFF]/12 blur-[150px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#00D26A]">
            Powered by Funz
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Meet Funz. Your AI career coach.
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-400 sm:text-lg">
            One intelligence across the whole OS — coaching your career, studies,
            money, kitchen and startup at the same time.
          </p>
          <ul className="mt-9 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {POWERS.map((p, i) => (
              <Reveal key={p} delay={0.05 * i}>
                <li className="flex list-none items-center gap-3 rounded-xl border border-white/10 bg-[#111827]/80 px-4 py-3.5">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#635BFF] to-[#00D26A]">
                    <Check className="h-3 w-3 text-white" />
                  </span>
                  <span className="text-sm font-medium text-slate-200">{p}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            data-testid="zeno-chat-mock"
            className="rounded-[2rem] border border-white/10 bg-[#111827]/70 p-6 backdrop-blur-2xl sm:p-8"
          >
            <div className="mb-6 flex items-center justify-between">
              <span className="flex items-center gap-2 font-jbmono text-[10px] uppercase tracking-[0.25em] text-slate-400">
                <span className="animate-pulse-dot h-1.5 w-1.5 rounded-full bg-[#00D26A]" />
                Funz · online
              </span>
              <Bot className="h-4 w-4 text-[#635BFF]" />
            </div>
            <div className="space-y-4">
              <div className="ml-auto max-w-[85%] rounded-2xl rounded-tr-md border border-[#635BFF]/30 bg-[#635BFF]/15 px-4 py-3 text-left">
                <p className="text-sm text-slate-100">
                  I have a product-design interview Friday. Help?
                </p>
              </div>
              <div className="max-w-[90%] rounded-2xl rounded-tl-md border border-white/10 bg-white/[0.04] px-4 py-3 text-left">
                <p className="font-jbmono text-[10px] uppercase tracking-widest text-[#00D26A]">
                  Funz · Career Coach
                </p>
                <p className="mt-1 text-sm text-slate-200">
                  Booked a mock interview Thursday 6pm. Your LearnNova portfolio already
                  covers 4 of the 6 skills they test — I'll drill the other two.
                </p>
              </div>
              <div className="max-w-[90%] rounded-2xl rounded-tl-md border border-white/10 bg-white/[0.04] px-4 py-3 text-left">
                <p className="text-sm text-slate-200">
                  Also polished your resume summary. Match probability:{" "}
                  <span className="font-bold text-[#00D26A]">87%</span>.
                </p>
              </div>
            </div>
            <div className="mt-6 flex items-center gap-3 rounded-full border border-white/10 bg-[#09090B]/80 px-5 py-3.5">
              <span className="flex-1 text-left text-sm text-slate-500">Ask Funz anything…</span>
              <Send className="h-4 w-4 text-[#635BFF]" />
            </div>
            <p className="mt-4 text-center font-jbmono text-[10px] uppercase tracking-widest text-slate-600">
              Demo preview — AI responses are illustrative
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
